import { createContext, useContext } from 'react';
import { OnboardingBrand } from './useGettingStartedOnboarding';

export type DiscordCtaSource = 'first_page' | 'deployment_step';

export interface OnboardingBrandContextValue {
  /**
   * Effective onboarding brand — 'discord' when the founding user's attribution OR their live
   * Deployment-step channel pick shows Discord intent. Drives the whole flow's deep-space
   * background + "Quickchat AI for Discord" lockup and the Discord content.
   */
  brand: OnboardingBrand;
  /** Opens the shared one-click Discord sheet overlay and fires the funnel event. */
  openDiscordSheet: (source: DiscordCtaSource) => void;
}

const OnboardingBrandContext = createContext<OnboardingBrandContextValue | null>(null);

export const OnboardingBrandProvider = OnboardingBrandContext.Provider;

/** Degrades to a no-op default when rendered outside the provider (e.g. isolated tests). */
export function useOnboardingBrand(): OnboardingBrandContextValue {
  return (
    useContext(OnboardingBrandContext) ?? {
      brand: 'default',
      openDiscordSheet: () => {},
    }
  );
}

/** Radix portals mount under `<body>`, outside the flow's themed shell, so portaled content has to carry the palette itself. */
export function useOnboardingPortalTheme(): string | undefined {
  return useOnboardingBrand().brand === 'discord' ? 'dark' : undefined;
}
